import CiroDropdown from "../../../../shared/CiroDropdown";
import classNames from "classnames";

const PowersearchOperatorSelector = ({
  operators,
  onChangeOperator,
  selectedOperator,
}: {
  operators: {
    name: string;
    label: string;
    valueEditorType: string;
  }[];
  onChangeOperator: (operator: string) => void;
  selectedOperator: string;
}) => {
  // <div> is necessary for spacing in parent div
  if (!operators) return <div></div>;

  return operators.length === 1 ? (
    <div className={classNames("text-sm", "text-gray-700")}>
      {operators[0].label}
    </div>
  ) : (
    <CiroDropdown
      options={operators.map((operator) => ({
        label: operator.label,
        value: operator.name,
      }))}
      value={selectedOperator}
      onChange={onChangeOperator}
    />
  );
};

export default PowersearchOperatorSelector;
